// extracted by mini-css-extract-plugin
export default {"overlayloginbgimg":"Registration_overlayloginbgimg__Yjk9v","buttondivcontainer":"Registration_buttondivcontainer__8vopQ","registerButton":"Registration_registerButton__us7Il"};